// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./$.cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/core-js/library/modules/$.iobject.js
 ** module id = 35
 ** module chunks = 2
 **/